import React, { useState } from "react";
import { CrossFillMini } from "../../assets/SvgIcons";

const yesConditions = [
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4305/4305522.png",
    name: "Case",
    id: "caseId",
    cons: [
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Case_none.jpg",
        title: "None",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Case_slight.jpg",
        title: "Barely Visible",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Case_moderate.jpg",
        title: "Noticeable",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Case_heavy.jpg",
        title: "Obvious",
      },
    ],
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4305/4305522.png",
    name: "Dial",
    id: "dialId",
    cons: [
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Dial_none.jpg",
        title: "None",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Dial_slight.jpg",
        title: "Barely Visible",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Dial_moderate.jpg",
        title: "Noticeable",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Dial_heavy.jpg",
        title: "Obvious",
      },
    ],
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4305/4305522.png",
    name: "Bezel",
    id: "bezelId",
    cons: [
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Bezel_none.jpg",
        title: "None",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Bezel_slight.jpg",
        title: "Barely Visible",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Bezel_moderate.jpg",
        title: "Noticeable",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Bezel_heavy.jpg",
        title: "Obvious",
      },
    ],
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4305/4305522.png",
    name: "Crystal",
    id: "crystalId",
    cons: [
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Glass_none.jpg",
        title: "None",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Glass_slight.jpg",
        title: "Barely Visible",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Glass_moderate.jpg",
        title: "Noticeable",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Glass_heavy.jpg",
        title: "Obvious",
      },
    ],
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4305/4305522.png",
    name: "Case Back",
    id: "caseBackId",
    cons: [
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Caseback_none.jpg",
        title: "None",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Caseback_slight.jpg",
        title: "Barely Visible",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Caseback_moderate.jpg",
        title: "Noticeable",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/Caseback_heavy.jpg",
        title: "Obvious",
      },
    ],
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/128/4305/4305522.png",
    name: "Band and clasp",
    id: "bandId",
    cons: [
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/BraceletAndClasp_none.jpg",
        title: "None",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/BraceletAndClasp_slight.jpg",
        title: "Barely Visible",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/BraceletAndClasp_moderate.jpg",
        title: "Noticeable",
      },
      {
        img: "https://static.chrono24.com/images/default/deficiencies/1x1/BraceletAndClasp_heavy.jpg",
        title: "Obvious",
      },
    ],
  },
];

const Step6 = ({ conditionSelected, setConditionSeleted }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [selectedCons, setSelectedCons] = useState({
    caseId: "",
    dialId: "",
    bezelId: "",
    crystalId: "",
    caseBackId: "",
    bandId: "",
  });

  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
        Indicate the Condition of Your Watch
      </h1>
      <p className="text-[14px] mt-4 mb-8">
        Please indicate any signs of wear such as scratches or dents.
      </p>

      <div className="my-12">
        <p className="font-medium text-[14px]">
          Does your watch have signs of wear?
        </p>

        <div className="flex gap-6 mt-4">
          <button
            className={`py-1.5 px-5 rounded-full border ${
              conditionSelected === "YES" && "bg-secondary text-white"
            }`}
            onClick={() => setConditionSeleted("YES")}
          >
            {" "}
            Yes
          </button>
          <button
            className={`py-1.5 px-5 rounded-full border ${
              conditionSelected === "NO" && "bg-secondary text-white"
            }`}
            onClick={() => setConditionSeleted("NO")}
          >
            {" "}
            No
          </button>
        </div>
      </div>

      {conditionSelected === "YES" && (
        <div className=" text-[14px] mb-8">
          <p className="font-medium">Signs of wear – individual components</p>

          <div className="grid grid-cols-3 gap-4 mt-6">
            {yesConditions?.map((yescon, index) => {
              return (
                <div key={index} className="border rounded-lg p-4">
                  <div className="flex gap-2 items-center">
                    <img
                      src={yescon?.icon}
                      alt=""
                      height={32}
                      width={32}
                      className="rounded"
                    />
                    <p className="text-[14px] font-medium">{yescon?.name}</p>
                  </div>

                  <p
                    onClick={() => {
                      openModal();
                      setSelectedIndex(index);
                    }}
                    className="underline text-[12px] mt-6 cursor-pointer"
                  >
                    Indicate now
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-2xl w-full max-w-[720px]">
            <div className="flex justify-between items-start">
              <h1 className="lg:text-3xl md:text-2xl sm:text-xl">
                Signs of wear – individual components
              </h1>
              <button className="" onClick={closeModal}>
                {CrossFillMini}
              </button>
            </div>
            <p className="text-[14px] mt-4 mb-8">
              Please select the appropriate condition.
            </p>

            <div className="flex gap-3 items-start mt-6">
              {yesConditions[selectedIndex]?.cons?.map((c, index) => {
                return (
                  <div
                    className={`flex flex-col border justify-center items-center p-2 rounded cursor-pointer ${
                      Object.values(selectedCons)[selectedIndex] === c.img &&
                      "border-black"
                    }`}
                    onClick={() =>
                      setSelectedCons({
                        ...selectedCons,
                        [yesConditions[selectedIndex].id]: c.img,
                      })
                    }
                  >
                    <img
                      src={c?.img}
                      alt=""
                      height={200}
                      width={200}
                      className="rounded"
                    />
                    <p className="text-[16px] mt-2 text-center">{c?.title}</p>
                  </div>
                );
              })}
            </div>

            <div className="w-full flex justify-end mt-10">
              <button
                className="mt-4 px-12 py-2.5 bg-secondary text-white rounded-lg"
                onClick={closeModal}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="text-[14px]">
        <p className="font-medium mb-2 ">Overall condition</p>
        <p className="text-gray-500">
          After indicating any signs of wear, you can view the overall condition
          of your watch here.
        </p>
      </div>
    </section>
  );
};

export default Step6;
